<template>
  <div class='speaking-card-wrap'>
    <template v-if='!isResultShow'>
      <div class='page-title-wrap'>
        <a-spin :spinning='titleLoading'>
          <div class='page-title-group'>
            <div class='page-title'>{{ title }}</div>
          </div>
        </a-spin>
        <a-spin :spinning='timeLoading' v-if='!isView'>
          <div class='right-wrap'>
            <div class='right-title'>倒计时：</div>
            <div class='right-time'>{{ content }}</div>
          </div>
        </a-spin>
      </div>
      <a-spin :spinning='pageLoading'>
        <div class='speaking-task-page-wrap'>
          <a-alert v-if='!isView' style='padding: 0.15rem 0.32rem;' :message="'请按以下脚本描述执行操作步骤'" type='info' closable />
          <div ref="modalSelectRoot"></div>
          <a-form :form='form'>
            <a-form-item
              :colon='false'
              :key='index'
              v-for='(item,index) in scriptsList'>
              <div class='scripts-wrapper'>
                <div>
                  <div class='title-group'>
                    {{ getLabel(item, index) }}
                  </div>
                </div>
                <div style='display: flex; justify-content:left;padding-left: 15px'>
                  <div style="min-width: 0.7rem;">脚本描述：</div>
                  <div  class="html-detail" v-html='item.content' />
                </div>
                <div style='padding-left: 15px'>
                  <span>脚本附件：</span>
                  <template v-for='(list, index) in item.attachmentList'>
                    <a :key='index' @click='_download(list)'>
                      <span>{{ list.name }}</span><span v-if='item.attachmentList.length!==(index+1)'>、</span>
                    </a>
                  </template>
                </div>
              </div>
            </a-form-item>
            <div class='speaking-title' style='margin-top: 15px;margin-bottom: 15px'>操作反馈</div>
            <a-row :gutter='24' v-if='!isView' style='margin-top: 15px'>
              <a-col :span='25'>
                <a-form-item label='操作结果'>
                  <a-select
                    :getPopupContainer='getPopupContainer'
                    :options='(options&&options.speakingResult)||[]'
                    placeholder='请选择'
                    :allowClear='true'
                    v-decorator="['speakingTasksResult', {rules: [{required: true, message: '请选择'}]}]" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter='24' v-if='!isView' style='margin-top: 15px'>
              <a-col span='25'>
                <a-form-item label='结果图片'>
                  <a-upload
                    :file-list='uploadFileList'
                    :data='fileData'
                    :action='_uploadAction'
                    :beforeUpload="_beforeUploadImage"
                    list-type="picture-card"
                    :remove='delAttachment'
                    @change='handleAttachmentChange'
                    @preview='previewImage'
                  >
                    <div v-if='uploadFileList.length < 10'>
                      <a-icon type='plus' />
                      <div class='ant-upload-text'>
                        上传
                      </div>
                    </div>
                  </a-upload>
                  <span>支持扩展名：.jpg. png .jpge最大单个100M  最多10个</span>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter='24' v-if='!isView' style='margin-top: 15px'>
              <a-col :span='25'>
                <a-form-item label='操作反馈'>
                  <a-input
                    :auto-size='{ minRows: 3, maxRows: 5 }'
                    type='textarea'
                    placeholder='请输入'
                    v-decorator="['speakingTasksContent', {rules: [{ max: 500, message: '最多输入500个字'}]}]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <detail-list :col="1" v-if='isView'>
              <detail-list-item term="操作结果">
                <div>{{ options.speakingResult && record.speakingTasksResult && options.speakingResult.filter(item => record.speakingTasksResult + '' === item.value)[0].label }}</div>
              </detail-list-item>
            </detail-list>
            <detail-list :col="1" v-if='isView'>
              <detail-list-item term="结果图片">
                <div style='display: flex;flex-wrap: wrap'>
                  <div :key="item.id" v-for="(item, index) in record.attachmentList">
                    <img  @click='preview(item.url)' style="width: 252px;height: 132px;cursor: pointer;" :src="baseUrl + item.url"/>
                  </div>
                </div>
              </detail-list-item>
            </detail-list>
            <detail-list :col="1" v-if='isView'>
              <detail-list-item term="操作反馈">
                <div>{{ record.speakingTasksContent }}</div>
              </detail-list-item>
            </detail-list>
            <detail-list :col="1" v-if='isView && record.speakingTasksFinalResult'>
              <detail-list-item term="最终操作结果">
                <div>{{ options.speakingResult && record.speakingTasksFinalResult && options.speakingResult.filter(item => record.speakingTasksFinalResult + '' === item.value)[0].label }}</div>
              </detail-list-item>
            </detail-list>
            <div class='right-btn-box'  v-if='!isView'>
              <a-button @click="() => handleOk('0')" class='sub-btn' shape='round' type='primary'>提交</a-button>
            </div>
            <div class="footer-btn-box" v-if='isView'>
              <a-button @click="$router.back()">返回</a-button>
            </div>
          </a-form>
        </div>
      </a-spin>
    </template>
    <submit-result v-if='isResultShow' />
  </div>
</template>
<script>
import SubmitResult from './submitResult'
import {
  getSpeakingTasksPublishScriptsList,
  getSpeakingTasksResult,
  getStartDate,
  saveSpeakingTasksResult
} from '@/api/speaking'
import { mapState } from 'vuex'
import { getListByCode } from '@/api/dict'
import { AttachmentApi } from '@/api/attachment'
import DetailList from '@/components/DescriptionList'
const DetailListItem = DetailList.Item
const iid = undefined
export default {
  name: 'speakingTasks',
  components: {
    SubmitResult,
    DetailList,
    DetailListItem
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      imageUrl: '',
      record:{},
      uploadFileList: [],
      attachmentList: [],
      attachmentIdList: [],
      form: this.$form.createForm(this),
      isPage: true,
      isView: false,
      speakingTasks: [],
      scriptsList: [],
      publishId: undefined,
      classId: undefined,
      list: [],
      title: '',
      content: '00:00',
      pageSize: undefined,
      parameters: { speakingTasksPublishId: undefined, classId: undefined },
      pageStart: 1,
      duration: undefined,
      isTipShow: false,
      isResultShow: false,
      remainTimestamp: undefined,
      newData: [],
      submitFlag: false,
      timerKey: undefined,
      timeLoading: true,
      titleLoading: true,
      pageLoading: false,
      score: 0,
      dictCode: 'speakingResult',
      options: {},
      speakingTasksResultId: undefined,
    }
  },
  computed: {
    ...mapState({
      userData: state => {
        if (state.user.userData.name) {
          return state.user.userData
        } else {
          return JSON.parse(localStorage.getItem('user'))
        }
      }
    })
  },
  filters: {},
  methods: {
    preview(data){
      window.open(process.env.VUE_APP_BASE_URL + data)
    },
    _beforeUploadImage(file) {
      const imgStr = /\.(jpg|jpeg|png|JPG|PNG|JPEG)$/
      if (!imgStr.test(file.name)) {
        this.$message.warning('只能上传图片文件')
        return false
      }
      if (file.size >= 1048576 * 100) {
        this.$message.warning('单个文件上传最大为100M')
        return false
      }
      return true
    },
    getPopupContainer() {
      return this.$refs.modalSelectRoot
    },
    handleAttachmentChange({ file, fileList }) {
      if (file.status) {
        this.uploadFileList = [...fileList]
      }
      if (file.status === 'done') {
        if (file.response.status === 200) {
          if (this.attachmentList === null) this.attachmentList = []
          this.attachmentList.push(file.response.result)
          this.attachmentIdList.push(file.response.result.id)
        } else {
          this.$message.error(file.response.message)
        }
      }
    },
    // 删除附件
    delAttachment(file) {
      let id = undefined
      if (file.type && file.type === '1') {
        id = file.uid
      } else {
        id = file.response.result.id
      }
      const that = this
      that.attachmentIdList.splice(that.attachmentIdList.findIndex(item => item === id), 1)
      for (let i = 0; i < that.attachmentList.length; i++) {
        if (that.attachmentList[i].id === id) {
          that.attachmentList.splice(i, 1)
        }
      }
    },
    //预览附件
    previewImage(file) {
      if (file.type && file.type === '1') {
        window.open(file.url)
      } else {
        window.open(process.env.VUE_APP_BASE_URL + file.response.result.url)
      }
    },
    _uploadAction() {
      return AttachmentApi.uploadAttachment()
    },
    fileData() {
      return { remark: '结果图片', tableName: 't_biz_attachment', subBizType: '1', bizTableName: 'speaking_tasks_result' }
    },
    _download(file) {
      window.open(process.env.VUE_APP_BASE_URL + file.url)
    },
    getLabel(value, index) {
      const label = index + 1 + '.' + '脚本名称：' + value.title
      return label
    },
    initView(){
      this.uploadFileList = []
      this.attachmentIdList = []
      Promise.all([
        getStartDate(Object.assign(this.parameters, {})),
        getSpeakingTasksResult({ id: this.speakingTasksResultId,speakingTasksPublishId:this.parameters.speakingTasksPublishId}),
        getListByCode({ dictCode: this.dictCode })
      ]).then(res => {
        this.title = res[0].result.title
        this.speakingTasksResultId = res[0].result.id
        this.scriptsList = res[1].result.list
        this.record = res[1].result.speakingTasksResult
        if (this.record.attachmentList && this.record.attachmentList.length > 0) {
          this.record.attachmentList.map(item => {
            this.imageUrl = process.env.VUE_APP_BASE_URL + item.url
          })
        }
        sessionStorage.setItem('testTitle', this.title)
        this.options = { ...this.options, ...res[2].result.dictDefine }
        this.titleLoading = false
        this.pageLoading = false
      })
    },
    init() {
      this.uploadFileList = []
      this.attachmentIdList = []
      Promise.all([
        getStartDate(Object.assign(this.parameters, {})),
        getSpeakingTasksPublishScriptsList({ id: this.parameters.speakingTasksPublishId }),
        getListByCode({ dictCode: this.dictCode })
      ]).then(res => {
        this.title = res[0].result.title
        this.speakingTasksResultId = res[0].result.id
        this.scriptsList = res[1].result.list
        sessionStorage.setItem('testTitle', this.title)
        if (!this.isView) {
          this.countDown(res[0].result.speakingTasksDate)
        }
        this.options = { ...this.options, ...res[2].result.dictDefine }
        this.titleLoading = false
        this.pageLoading = false
      })
    },
    /*倒计时方法*/
    countDown(timestamp) {
      this.remainTimestamp = timestamp
      const self = this
      const timer = setInterval(function() {
        self.remainTimestamp = self.remainTimestamp - 1000
        const t = self.remainTimestamp
        if (t > 0) {
          const day = Math.floor(t / 86400000)
          let hour = Math.floor((t / 3600000) % 24)
          let min = Math.floor((t / 60000) % 60)
          let sec = Math.floor((t / 1000) % 60)
          hour = hour < 10 ? '0' + hour : hour
          min = min < 10 ? '0' + min : min
          sec = sec < 10 ? '0' + sec : sec
          let format = ''
          if (day > 0) {
            format = `${day}:${hour}:${min}:${sec}`
          }
          if (day <= 0 && hour > 0) {
            format = `${hour}:${min}:${sec}`
          }
          if (day <= 0 && hour <= 0) {
            format = `${min}:${sec}`
          }
          self.content = format
          self.timeLoading = false
        } else {
          clearInterval(timer)
          self.content = '00:00'
          if (!self.submitFlag) {
            self.handleOk('1')
            self.handleAutomatic()
          }
          self.timeLoading = false
        }
      }, 1000)
      this.timerKey = timer
    },
    handleAutomatic() {
      this.$message.warn('考试已结束，已自动提交')
    },
    handleOk(flag) {
      if (flag==='0'){
        this.form.validateFields((err, values) => {
          if (!!this.attachmentIdList && this.attachmentIdList.length>10){
            this.$message.warn('最多上传两个图片！')
            err = true
          }
          if (!err) {
            this.pageLoading = true
            values.attachmentIdList = this.attachmentIdList
            values.id = this.speakingTasksResultId
            saveSpeakingTasksResult(values).then(() => {
              this.isResultShow = true
              this.submitFlag = true
              this.isTipShow = false
              clearInterval(this.timerKey)
              this.pageLoading = false
            }).catch(() => {
              document.body.style.position = 'static'
              sessionStorage.removeItem('user')
              sessionStorage.removeItem('speakingTasks')
              this.$router.push({ path: '/login' })
            })
          }
        })
      }else {
        this.form.validateFields((err, values) => {
          this.pageLoading = true
          values.attachmentIdList = this.attachmentIdList
          values.id = this.speakingTasksResultId
          saveSpeakingTasksResult(values).then(() => {
            this.isResultShow = true
            this.submitFlag = true
            this.isTipShow = false
            clearInterval(this.timerKey)
            this.pageLoading = false
          }).catch(() => {
            document.body.style.position = 'static'
            sessionStorage.removeItem('user')
            sessionStorage.removeItem('speakingTasks')
            this.$router.push({ path: '/login' })
          })
        })
      }
    }
  },
  //获取数据
  created() {
    // 如果不存在试卷所需数据，则跳转到试卷列表
    if (!sessionStorage.getItem('speakingTasks')) {
      this.$router.push('/home/homeSpeakingTasksMsgCard')
      return
    }
    this.timeLoading = true
    this.titleLoading = true
    this.pageLoading = true
    this.speakingTasks = JSON.parse(sessionStorage.getItem('speakingTasks'))
    this.duration = this.speakingTasks.duration
    this.publishId = this.speakingTasks.speakingTasksPublishId
    this.classId = this.speakingTasks.classId
    this.parameters.speakingTasksPublishId = this.speakingTasks.speakingTasksPublishId
    this.parameters.classId = this.speakingTasks.classId
    if (this.$route.query.show === '0') {
      this.isView = true
      this.speakingTasksResultId = this.speakingTasks.speakingTasksResultId
      this.initView()
    }else {
      this.init()
    }
  }

}
</script>
<style lang='less'>
.speaking-card-wrap {
  .result-img{
    width: 200px;
    height: 140px;

  }
  .ant-form-item {
    display: flex;

    .ant-form-item-label {
      min-width: 100px;
    }

    .ant-form-item-control-wrapper {
      flex: 1
    }
  }
  .ant-form-item {
    margin-bottom: 0 !important;
  }

  .term {
    min-width: 110px;
    text-align: right;
    color: #000000;
  }
  .speaking-title {
    font-weight: 600;
    color: #191d28;
    font-size: 20px;
    padding-bottom: 1.33px;
    line-height: 32px;
  }

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;

  .page-title-wrap {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #E8ECEF;
    border-left: 1px solid #E8ECEF;
    border-right: 1px solid #E8ECEF;
    border-top-left-radius: 0.1rem;
    border-top-right-radius: 0.1rem;
    padding: 0.15rem 0.32rem;

    .page-title-group {
      display: flex;
      align-items: center;
      margin-bottom: 0;

      .page-icon {
        display: block;
        width: 16px;
        height: 16px;
        margin-right: 0.08rem;

        &.icon-text {
          background: url('../../assets/icons/ic_exam_line@2x.png') center/100% 100% no-repeat;
        }
      }
    }

    .page-title {
      font-weight: 600;
      color: #191d28;
      font-size: 20px;
      padding-bottom: 1.33px;
      line-height: 32px;
    }

    .right-wrap {
      display: flex;
      align-items: center;

      .right-title {
        font-weight: 600;
        color: #183b56;
        font-size: 16px;
      }

      .right-time {
        color: rgba(233, 30, 99, 1);
        font-size: 0.32rem;
        font-weight: bold;
      }
    }
  }

  .speaking-task-page-wrap {
    background: white;
    border: 1px solid #E8ECEF;
    padding: 0.15rem 0.32rem;
    border-bottom-left-radius: 0.1rem;
    border-bottom-right-radius: 0.1rem;
  }

  @media screen and (max-width: 768px) {
    .page-title-wrap .page-title {
      font-size: 16px;
    }
  }

  .scripts-wrapper {
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #D3DFEF;
    padding-bottom: 1px;
    margin-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .title-group {
    font-weight: bold;
  }

  .right-btn-box {
    text-align: center;
    margin-top: 0.4rem;

    .ant-btn-round {
      border-radius: 4px;
      height: 35px;
    }

    .sub-btn {
      padding: 0 0.3rem;
    }
  }
  .footer-btn-box {
    bottom: 0;
    right: 0;
    width: 100%;
    line-height: 56px;
    background: #fff;
    padding: 0 24px;
    z-index: 9;
    text-align: center;

    .ant-btn {
      width: 100px;
      height: 40px;
      font-size: 16px;
    }
  }

}
</style>
